import styled from "styled-components";

export const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
